// redux/slices/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { authReducer } from "../Reducer/authReducer";

const initialState = {
  auth: {
    loading: false,
    user: null,
    isAuth: false,
    accessToken: null,
    refreshToken: null,
    error: null,
    isUserUpdated: true,
  },

};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      localStorage.setItem("accessToken", action.payload)
      state.auth.accessToken = action.payload;
    },
    clearToken: (state, action) => {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("tcs_daily_hours_monthly_access_v1");
      state.auth.accessToken = null;
      state.auth.isAuth = false;
    },
    setAuthLoading: (state, action) => {
      state.auth.loading = action.payload;
    }
  },
  extraReducers: (builder) => {
    authReducer(builder);
  },
});

export const { setToken, clearToken, setAuthLoading } = authSlice.actions;
export default authSlice.reducer;
